import React from 'react';
import { Gift, AlertCircle } from 'lucide-react';

interface PrizeInstructionsFieldProps {
  value: string;
  onChange: (value: string) => void;
}

const PrizeInstructionsField: React.FC<PrizeInstructionsFieldProps> = ({ value, onChange }) => {
  const charCount = value?.length || 0;
  const maxChars = 5000;

  return (
    <div className="space-y-2">
      <label htmlFor="prizeInstructions" className="flex items-center text-xs font-bold uppercase tracking-wider text-tinta">
        <Gift className="h-4 w-4 mr-2 text-bordo" />
        Instruções de Resgate do Prêmio
        <span className="ml-2 text-[10px] text-tinta-soft italic normal-case tracking-normal font-normal">(Opcional)</span>
      </label>

      <div className="bg-tinta/5 border-l-4 border-bordo/60 rounded-lg p-3 mb-3">
        <div className="flex">
          <AlertCircle className="h-5 w-5 text-bordo mr-2 flex-shrink-0" />
          <div className="text-sm text-tinta-soft">
            <p className="font-bold text-tinta mb-1">Mensagem Automática via WhatsApp</p>
            <p className="text-xs italic">
              Após o usuário ganhar um prêmio, uma mensagem será enviada automaticamente
              no WhatsApp com estas instruções. Se deixar vazio, será enviada uma mensagem genérica.
            </p>
          </div>
        </div>
      </div>

      <textarea
        id="prizeInstructions"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        rows={8}
        maxLength={maxChars}
        placeholder={`Exemplo:\n\nComo resgatar:\n\n1. Compareça em nossa loja na Rua X, 123\n2. Apresente este WhatsApp na recepção\n3. Horário de atendimento: Seg-Sex 9h-18h\n\nPrazo: 30 dias a partir da data do sorteio\n\nDúvidas? Ligue (11) 1234-5678`}
        className="mt-1 block w-full bg-white border border-tinta/15 rounded-lg px-3 py-2.5 text-sm text-tinta placeholder:text-tinta-soft/70 placeholder:italic focus:outline-none focus:ring-2 focus:ring-bordo/40 focus:border-bordo transition-colors resize-y font-mono"
      />

      <div className="flex justify-between items-center text-xs">
        <span className="text-tinta-soft italic">
          {value ? (
            <span>
              Mensagem personalizada
            </span>
          ) : (
            <span className="text-mostarda-dark">
              Mensagem genérica será usada se deixar vazio
            </span>
          )}
        </span>
        <span className={`font-bold ${charCount > maxChars * 0.9 ? 'text-bordo' : 'text-tinta-soft'}`}>
          {charCount.toLocaleString()} / {maxChars.toLocaleString()} caracteres
        </span>
      </div>

      {value && (
        <div className="mt-3 p-3 bg-creme-light/50 border border-tinta/15 rounded-lg">
          <p className="text-xs font-bold uppercase tracking-wider text-tinta mb-2">Preview da mensagem:</p>
          <div className="bg-white p-3 rounded-lg border border-tinta/15 text-sm whitespace-pre-wrap font-sans">
            <p className="font-bold text-musgo-dark mb-1">Parabéns, João!</p>
            <p className="mb-2 text-tinta">Você ganhou: <strong>Desconto 50%</strong></p>
            <p className="text-xs text-tinta-soft italic mb-2">Na roda: Promoção de Natal</p>
            <div className="border-t border-tinta/10 pt-2 mt-2">
              <p className="font-bold text-tinta mb-1">Como resgatar seu prêmio:</p>
              <p className="text-tinta-soft">{value}</p>
            </div>
            <div className="border-t border-tinta/10 pt-2 mt-2 text-xs text-tinta-soft italic">
              Sua Empresa
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrizeInstructionsField;
